module.exports = __webpack_public_path__ + "media/images/missile_ic-11a14cb780840e88512658bec8ffde3a.svg";